import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { TAPIPaymentStatus } from '../../../../types/api'

const statusColors = {
  canceled: { color: '#ccc200', backgroundColor: 'rgba(255, 255, 0, 0.3)' },
  expired: { color: '#ffa500', backgroundColor: 'rgba(255, 166, 0, 0.3)' },
  failed: { color: '#ff0000', backgroundColor: 'rgba(232, 69, 60, 0.3)' },
  paid: { color: '#008000', backgroundColor: 'rgba(116, 224, 65, 0.3)' },
  collected: { color: '#005cd9', backgroundColor: 'rgba(0, 92, 217,0.14)' },
  requested: { color: '#989898', backgroundColor: 'rgba(232, 232, 232, 0.8)' },
}

export const PaymentStatusMessageContainer = styled.div<{
  paymentStatus: TAPIPaymentStatus
}>`
  background: ${({ paymentStatus }) =>
    statusColors[paymentStatus].backgroundColor};
  border-radius: 25px;
  margin: 16px;
`

export const PaymentStatusMessageWrapper = styled.div`
  display: flex;
  padding: 8px;
`

export const PaymentStatusMessageIcon = styled(FontAwesomeIcon)<{
  paymentStatus: TAPIPaymentStatus
}>`
  color: ${({ paymentStatus }) => statusColors[paymentStatus].color};
  font-size: 1.2rem;
  margin-top: 4px;
`

export const PaymentStatusMessageText = styled.p<{
  paymentStatus: TAPIPaymentStatus
}>`
  color: ${({ paymentStatus }) => statusColors[paymentStatus].color};
  margin: 0;
  margin-left: 8px;
`
